<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <h5 class="title is-5">{{ $t("devices.imageUpload.title") }}</h5>
    <div class="notification is-info is-light">
      {{ $t("devices.imageUpload.message") }}
    </div>

    <div class="control">
      <label class="label">{{ $t("devices.imageUpload.type") }}</label>
      <label class="radio">
        <input type="radio" name="imgtype" v-model="imgtype" value="img01" />
        {{ $t("devices.imageUpload.img01") }}
      </label>
      <label class="radio">
        <input type="radio" name="imgtype" v-model="imgtype" value="img02" />
        {{ $t("devices.imageUpload.img02") }}
      </label>
    </div>

    <div class="file has-name mt-4">
      <label class="file-label">
        <input
          class="file-input"
          @change="changeFile"
          type="file"
          name="imgfile"
          accept=".jpg, .jpeg, .png"
        />
        <span class="file-cta">
          <span class="file-icon">
            <i class="fas fa-upload"></i>
          </span>
          <span class="file-label">
            {{ $t("devices.imageUpload.fileselect") }}
          </span>
        </span>
        <span class="file-name">
          {{ uploadFileName }}
        </span>
      </label>
    </div>

    <div class="field mt-4">
      <div class="control">
        <button
          class="button is-primary"
          v-bind:disabled="isFile"
          @click.prevent="onSubmit"
          v-bind:class="{ 'is-loading': isLoad }"
        >
          {{ $t("Create") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import imsr from "@/imsr-api";
import { ref } from "@vue/reactivity";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    Breadcrumb,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const isLoad = ref(false);
    const deviceId = ref(route.params.deviceId);
    const breadcrumb = ref([
      {
        title: "Home",
        path: {
          name: "dashboard",
          params: { projectId: route.params.projectId },
        },
      },
      {
        title: "Device Config",
        path: {
          name: "devicesList",
          params: { projectId: route.params.projectId },
        },
      },
      {
        title: route.params.deviceId,
        path: {
          name: "devicesView",
          params: {
            projectId: route.params.projectId,
            deviceId: route.params.deviceId,
          },
        },
      },
      { title: "Image Upload", path: "#", isActive: true },
    ]);
    const uploadFile = ref();
    const uploadFileName = ref();
    const imgtype = ref("img01");
    const isFile = ref(true);
    const changeFile = (e) => {
      uploadFile.value = e.target.files[0];
      uploadFileName.value = e.target.files[0].name;
      if (uploadFileName.value != "") {
        isFile.value = false;
      } else {
        isFile.value = true;
      }
    };

    const onSubmit = async () => {
      try {
        isLoad.value = true;
        const ticketParams = {
          tenantId: store.getters.tenantId,
          projectId: route.params.projectId,
        };
        const ticket = await imsr.imsrGetApi(
          "/projects/getTicket",
          ticketParams
        );
        const params = new FormData();
        params.append("tenantId", store.getters.tenantId);
        params.append("projectId", route.params.projectId);
        params.append("userId", store.getters.userId);
        params.append("deviceId", route.params.deviceId);
        params.append("imageType", imgtype.value);
        params.append("ticket", ticket.movieTicket);
        params.append("file", uploadFile.value);
        await imsr.imsrImageUploadApi(params);
        isLoad.value = false;
        router.push({
          name: "devicesView",
          params: {
            projectId: route.params.projectId,
            deviceId: route.params.deviceId,
          },
        });
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };

    return {
      isLoad,
      breadcrumb,
      uploadFileName,
      imgtype,
      deviceId,
      onSubmit,
      changeFile,
      isFile,
    };
  },
};
</script>
